import { render, staticRenderFns } from "./headInfo.vue?vue&type=template&id=0b0877d9&"
import script from "./headInfo.vue?vue&type=script&lang=js&"
export * from "./headInfo.vue?vue&type=script&lang=js&"
import style0 from "./headInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports